import db from "./firebase"

var sendTrackingEvent = (message, obj, uid) => {
  mixpanel.track(message, obj)
  gtag('event', message, obj)
  var trackingLog = obj
  trackingLog.type = message
  trackingLog.created = new Date()
  console.log(db)
  db.collection("TRACKING_LOG")
    .add(trackingLog)
  console.log("sendTrackingEvent", message)
}

var identifyTrackedUser = (uid) => {
  mixpanel.identify(uid)
}

var trackedUserSignUp = (user) => {
  mixpanel.people.set(user)
}

export { sendTrackingEvent, trackedUserSignUp, identifyTrackedUser }
